"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var ParNewsEditor_1 = require("./component/ParNewsEditor");
var ParNewsLocaleEditor_1 = require("./component/ParNewsLocaleEditor");
var ParNewsLocaleRawEditor_1 = require("./component/ParNewsLocaleRawEditor");
var ParNewsLocaleCk4Editor_1 = require("./component/ParNewsLocaleCk4Editor");
var ParNewsList_1 = require("./component/ParNewsList");
var ParNewsLocalesList_1 = require("./component/ParNewsLocalesList");
var PParNewsList = /** @class */ (function (_super) {
    __extends(PParNewsList, _super);
    function PParNewsList(props) {
        return _super.call(this, props) || this;
    }
    PParNewsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.listPProgramsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.SID_AL = this.props.listAppLangsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_langs: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST-NEWS",
            item_category: null,
            item_record: null,
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_langs: [],
            page_category_num: 1,
            page_size: this.props.state.getTablePageSize(),
            page_data_num: 1,
            page_record_num: 1,
            base64_content: ""
        }, function () {
            _this.props.listPProgramsAvail.LoadData();
            _this.props.listAppLangsAvail.LoadData();
        });
    };
    PParNewsList.prototype.componentWillUnmount = function () {
        this.props.listPProgramsAvail.UnSubscribe(this.SID_AP);
        this.props.listAppLangsAvail.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PParNewsList.prototype.onNewCategoryClick = function () {
        this.setState({ edit_mode: "NEW-NEWS", item_category: null });
    };
    PParNewsList.prototype.onNewRecordClick = function () {
        this.setState({ edit_mode: "NEW-NEWS-LOCALE", item_record: null });
    };
    PParNewsList.prototype.onEditCategoryClick = function (id) {
        this.setState({ edit_mode: "EDIT-NEWS", item_category: id });
    };
    PParNewsList.prototype.onEditRecordClick = function (id) {
        this.setState({ edit_mode: "EDIT-NEWS-LOCALE", item_record: id });
    };
    PParNewsList.prototype.onEditRecordRawClick = function (id) {
        var _this = this;
        this.props.partnerNewsLocalesList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-NEWS-LOCALE-RAW", item_record: id, base64_content: base64Content });
        });
    };
    PParNewsList.prototype.onEditRecordCk4Click = function (id) {
        var _this = this;
        this.props.partnerNewsLocalesList.GetDataContent(id.key, function (base64Content) {
            _this.setState({ edit_mode: "EDIT-NEWS-LOCALE-CK4", item_record: id, base64_content: base64Content });
        });
    };
    PParNewsList.prototype.onCategoryDetailsClick = function (id) {
        this.setState({ edit_mode: "LIST-NEWS-LOCALE", item_category: id, item_record: null });
    };
    PParNewsList.prototype.onGoBackToCategoryListClick = function () {
        this.setState({ edit_mode: "LIST-NEWS", item_category: null });
    };
    PParNewsList.prototype.onGoBackToRecordListClick = function () {
        this.setState({ edit_mode: "LIST-NEWS-LOCALE", item_record: null });
    };
    PParNewsList.prototype.onPageCategoryConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_category_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PParNewsList.prototype.onPageRecordConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_record_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PParNewsList.prototype.onBrandFilterChanged = function (allPPrograms, PProgramId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllPPrograms(allPPrograms, true);
        }
        if (Action === "add") {
            this.props.state.addPProgram(PProgramId, true);
        }
        if (Action === "remove") {
            this.props.state.delPProgram(PProgramId, true);
        }
    };
    PParNewsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW-NEWS") {
            return (React.createElement(ParNewsEditor_1.default, { data: this.props.partnerNewsList, state: this.props.state, record: null, onGoBack: this.onGoBackToCategoryListClick.bind(this), pprogramsList: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "NEW-NEWS-LOCALE") {
            return (React.createElement(ParNewsLocaleEditor_1.default, { data: this.props.partnerNewsLocalesList, rootRecord: this.state.item_category, state: this.props.state, record: null, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs }));
        }
        if (this.state.edit_mode === "EDIT-NEWS") {
            return (React.createElement(ParNewsEditor_1.default, { data: this.props.partnerNewsList, state: this.props.state, record: this.state.item_category, onGoBack: this.onGoBackToCategoryListClick.bind(this), pprogramsList: this.state.avail_brands, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT-NEWS-LOCALE") {
            return (React.createElement(ParNewsLocaleEditor_1.default, { data: this.props.partnerNewsLocalesList, record: this.state.item_record, rootRecord: this.state.item_category, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), languagesList: this.state.avail_langs }));
        }
        if (this.state.edit_mode === "EDIT-NEWS-LOCALE-RAW") {
            return (React.createElement(ParNewsLocaleRawEditor_1.default, { data: this.props.partnerNewsLocalesList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content }));
        }
        if (this.state.edit_mode === "EDIT-NEWS-LOCALE-CK4") {
            return (React.createElement(ParNewsLocaleCk4Editor_1.default, { data: this.props.partnerNewsLocalesList, record: this.state.item_record, state: this.props.state, onGoBack: this.onGoBackToRecordListClick.bind(this), textBase64: this.state.base64_content, dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST-NEWS") {
            return (React.createElement(ParNewsList_1.default, { data: this.props.partnerNewsList, state: this.props.state, onNewClick: this.onNewCategoryClick.bind(this), onEditClick: this.onEditCategoryClick.bind(this), onPageConfigChanged: this.onPageCategoryConfigChange.bind(this), pageNum: this.state.page_category_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onDetailsClick: this.onCategoryDetailsClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST-NEWS-LOCALE") {
            return (React.createElement(ParNewsLocalesList_1.default, { data: this.props.partnerNewsLocalesList, state: this.props.state, root: this.state.item_category, onNewClick: this.onNewRecordClick.bind(this), onEditClick: this.onEditRecordClick.bind(this), onEditRawClick: this.onEditRecordRawClick.bind(this), onEditVisualClick: this.onEditRecordCk4Click.bind(this), onPageConfigChanged: this.onPageRecordConfigChange.bind(this), pageNum: this.state.page_data_num, pageSize: this.state.page_size, onGoBackClick: this.onGoBackToCategoryListClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PParNewsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PParNewsList.getPageDescription = function (state) {
        return {
            icon: "newspaper",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_par_news_list + "-id",
            itemTitle: "Новости",
            route: routes_1.routes.page_par_news_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PParNewsList;
}(React.Component));
exports.default = PParNewsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_news/ui/PParNewsList.tsx
// module id = 2478
// module chunks = 0